/**
 * Email Templates - Type Definitions
 *
 * Defines the data structures for email templates and folder tree navigation.
 */

import type { EmailTemplateListItem } from './api-types'

export type TemplateCategory = 'announcements' | 'reminders' | 'quarterly' | 'notifications'
export type TemplateAudience = 'physician' | 'non-physician' | 'all'

export interface EmailTemplate {
  id: string
  name: string
  path: string
  category: TemplateCategory
  audience: TemplateAudience
  subject: string
  description?: string
  folderId?: number | null
  lastModified?: string
}

export interface TemplateNode {
  id: string
  name: string
  type: 'folder' | 'file'
  path: string
  children?: TemplateNode[]
  /** Only present for file nodes */
  template?: EmailTemplate
}

/**
 * Maps EmailTemplateListItem (from API) to EmailTemplate (for tree builder)
 */
export function mapApiToEmailTemplate(item: EmailTemplateListItem): EmailTemplate {
  const path = `/email-templates/${item.category}/${item.audience}/${item.templateKey}.html`
  const lastModified = new Date(item.updatedAt).toISOString().split('T')[0]

  return {
    id: item.templateKey,
    name: item.name,
    path,
    category: item.category as TemplateCategory,
    audience: item.audience as TemplateAudience,
    subject: item.subject,
    description: item.description ?? undefined,
    folderId: item.folderId,
    lastModified,
  }
}
